// import React, { Component, Suspense } from 'react'
// import { BrowserRouter, Route, Routes } from 'react-router-dom'
// import './scss/style.scss'
// import Login from './views/other-pages/preAuth/Login'

// import AdminLogin from './views/other-pages/preAuth/AdminLogin'

// import PasswordRecovery from './views/other-pages/preAuth/PasswordRecovery'
// import PasswordReset from './views/other-pages/preAuth/PasswordReset'
// import PasswordRecoverySendOtp from './views/other-pages/preAuth/PasswordRecoverySendOtp'
// import DefaultLayout from './layout/DefaultLayout'
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// import AutoLogout from "./AutoLogout";

// // Optional: Attach token if you're using one
// axios.interceptors.request.use((config) => {
//   const token = sessionStorage.getItem('ASIToken'); // or from context
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// // Auto logout on 401
// axios.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response && error.response.status === 401) {
//       // Clear storage
//       sessionStorage.removeItem('ASIToken');
//       // Redirect to login
//       window.location.href = '/login'; // adjust path as needed
//     }
//     return Promise.reject(error);
//   }
// );

// if (window.location.hostname === 'localhost') {
//   axios.defaults.baseURL = "http://localhost:5003";
//   global.backendUrl = "http://localhost:5003";
// } else {
//   axios.defaults.baseURL = "https://appsecops-api.intruceptlabs.com";
//   global.backendUrl = "https://appsecops-api.intruceptlabs.com";}

// if (window.location.hostname === 'localhost') {
//   //global.reportAPIURL = "http://localhost/intrucept/report-generator/public";
//   global.reportAPIURL = "https://reporting.intruceptlabs.com";
// } else {
//   global.reportAPIURL = "https://reporting.intruceptlabs.com";
// }

// const loading = (
//   <div className="pt-3 text-center">
//     <div className="sk-spinner sk-spinner-pulse"></div>
//   </div>
// )

// class App extends Component {
//   render() {
//     return (
//       <BrowserRouter>
//         <AutoLogout>
//           <Routes>
//             <Route path="/" name="Login" element={<Login />} />
//             <Route exact path="/login" name="Login" element={<Login />} />
//             <Route exact path="/password-recovery" name="Password Recovery" element={<PasswordRecovery />} />
//             <Route exact path="/password-recovery-send-otp" name="Password Recovery Send OTP" element={<PasswordRecoverySendOtp />} />
//             <Route exact path="/password-reset" name="Password Reset" element={<PasswordReset />} />
//             <Route exact path="/admin-login" name="Admin Login" element={<AdminLogin />} />
//             <Route path="*" name="dashboard" element={<DefaultLayout />} />
//           </Routes>
//           <ToastContainer />
//         </AutoLogout>
//       </BrowserRouter>
//     );
//   }
// }

// export default App

import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import './scss/style.scss'
import Login from './views/other-pages/preAuth/Login'
import AdminLogin from './views/other-pages/preAuth/AdminLogin'
import PasswordRecovery from './views/other-pages/preAuth/PasswordRecovery'
import PasswordReset from './views/other-pages/preAuth/PasswordReset'
import PasswordRecoverySendOtp from './views/other-pages/preAuth/PasswordRecoverySendOtp'
import DefaultLayout from './layout/DefaultLayout'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import AutoLogout from './AutoLogout'
import Users from './views/app-pages/organization/users/users'
import ProtectedRoute from './components/ProtectedRoutes'
import UsersActivity from './views/app-pages/organization/users/usersActivity'

// Axios interceptors (unchanged)
axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('ASIToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('ASIToken')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)

global.reportAPIURL = "https://reporting.intruceptlabs.com";
if (window.location.hostname === 'localhost') {
  axios.defaults.baseURL = "http://localhost:5003";
  global.backendUrl = "http://localhost:5003";
 
} else {
  axios.defaults.baseURL = "https://appsecops-api.intruceptlabs.com";
  global.backendUrl = "https://appsecops-api.intruceptlabs.com";
}

// if (window.location.hostname === 'localhost') {
//   //global.reportAPIURL = "http://localhost/intrucept/report-generator/public";
 
// } else {
//   global.reportAPIURL = "https://reporting.intruceptlabs.com";
// }

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Create a component that wraps routes with the inactivity timer
function AppRoutes() {
  const navigate = useNavigate()

  // Custom hook for inactivity timer (modified to use window.location instead of navigate)
  const useInactivityTimer = (timeoutMinutes = 15) => {
    useEffect(() => {
      let inactivityTimer

      const resetTimer = () => {
        clearTimeout(inactivityTimer)
        inactivityTimer = setTimeout(() => {
          sessionStorage.clear()
          window.location.href = '/login' // Use window.location instead of navigate
        }, timeoutMinutes * 60 * 1000)
      }

      const events = ['mousedown', 'keypress', 'scroll', 'touchstart']
      events.forEach((event) => window.addEventListener(event, resetTimer))

      resetTimer()

      return () => {
        clearTimeout(inactivityTimer)
        events.forEach((event) => window.removeEventListener(event, resetTimer))
      }
    }, [])
  }

  useInactivityTimer(15) // Initialize timer

  return (
    <Routes>
      <Route path="/" name="Login" element={<Login />} />
      <Route exact path="/login" name="Login" element={<Login />} />
      <Route
        exact
        path="/password-recovery"
        name="Password Recovery"
        element={<PasswordRecovery />}
      />
      <Route
        exact
        path="/password-recovery-send-otp"
        name="Password Recovery Send OTP"
        element={<PasswordRecoverySendOtp />}
      />
      <Route exact path="/password-reset" name="Password Reset" element={<PasswordReset />} />
      <Route exact path="/admin-login" name="Admin Login" element={<AdminLogin />} />
      

      {/* Protected Users route */}
    <Route path="/" element={<DefaultLayout />}>
  <Route
    path="users"
    element={
      <ProtectedRoute allowedRoles={['Administrator']}>
        <Users />
      </ProtectedRoute>
    }
  />
  <Route
    path="user-activity"
    element={
      <ProtectedRoute allowedRoles={['Administrator']}>
        <UsersActivity />
      </ProtectedRoute>
    }
  />
</Route>


      <Route path="*" name="dashboard" element={<DefaultLayout />} />
    </Routes>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AutoLogout>
        <Suspense fallback={loading}>
          <AppRoutes />
          <ToastContainer />
        </Suspense>
      </AutoLogout>
    </BrowserRouter>
  )
}

export default App
